import { useCallback, useState } from "react";
import {
  readPinnedIds,
  removePinnedId,
  sortWithPins,
  togglePinnedId,
  writePinnedIds,
} from "../pinnedProfiles";

export function usePinnedProfiles(username: string | undefined) {
  const [pinnedIds, setPinnedIds] = useState<string[]>(() =>
    username ? readPinnedIds(username) : [],
  );
  const [storedUsername, setStoredUsername] = useState(username);

  if (username !== storedUsername) {
    setStoredUsername(username);
    setPinnedIds(username ? readPinnedIds(username) : []);
  }

  const persist = useCallback(
    (next: string[]) => {
      setPinnedIds(next);
      if (username) writePinnedIds(username, next);
    },
    [username],
  );

  const isPinned = useCallback(
    (id: string) => pinnedIds.includes(id),
    [pinnedIds],
  );

  const togglePinned = useCallback(
    (id: string) => {
      persist(togglePinnedId(pinnedIds, id));
    },
    [pinnedIds, persist],
  );

  const removePinned = useCallback(
    (id: string) => {
      persist(removePinnedId(pinnedIds, id));
    },
    [pinnedIds, persist],
  );

  const sortProfilesWithPins = useCallback(
    <T extends { id: string }>(items: T[]) => sortWithPins(items, pinnedIds),
    [pinnedIds],
  );

  return {
    pinnedIds,
    isPinned,
    togglePinned,
    removePinned,
    sortProfilesWithPins,
  };
}
